/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementListMemberResponse } from './MemberManagementListMemberResponse';

export type MemberManagementListMemberResponseApiRespoonse = {
    data?: MemberManagementListMemberResponse;
    status?: MemberManagementListMemberResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementListMemberResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

